/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name inputtime
 * @description Test input with a popover time selector
 */
angular.module('mercury.directives.inputtime', [])
.directive('inputtime', ["$compile", "$document", "$parse", function($compile, $document, $parse) {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: true,
    transclude: true,
    replace: true,
    templateUrl: 'directives/inputtime/inputtime.tpl.html',
    link: function(scope, element, attrs) {
      //Setup the local models for the time picker and input box
      scope.time = moment($parse(attrs.ngModel)(scope)).format();
      scope.display = moment($parse(attrs.ngModel)(scope)).format('h:mma');

      scope.$watch(attrs.ngModel, function(newModelValue) {
        if (newModelValue) {
          scope.time = moment(newModelValue).format();
          scope.display = moment(newModelValue).format('h:mma');
        } else {
          scope.time = null;
          scope.display = '';
        }
      });

      /**
      * ngChange callback for setting the time or date
      */
      scope.updateDateTime = function() {
        //If the user is entering hours or minutes in the inputs of the timepicker, the time can be null
        //If this is the case, don't continue until the time is valid again.
        if (!scope.time) {
          return;
        }

        var time = moment(scope.time);

        //Update the model and the displayed labal
        $parse(attrs.ngModel).assign(scope, time.format());
        scope.display = time.format('h:mma');
      };

      if (attrs.ngDisabled) {
        scope.disabled = $parse(attrs.ngDisabled)(scope);

        scope.$watch(attrs.ngDisabled, function(disabled) {
          scope.disabled = disabled;
        });
      }
    }
  };
}]);
